import React, { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { notify } from 'helpers/notificationHelper';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Autocomplete from '@mui/material/Autocomplete';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';

// Settings page components
import FormField from 'layouts/pages/account/components/FormField';

import { useFormik } from 'formik';
import * as yup from 'yup';

import { postSMS } from 'services/api/general/sms';

const validationSchema = yup.object({
    relatedID: yup
        .string('Başlık giriniz')
        .min(5, '5 karakterden fazla olmalıdır')
        .max(200, '200 karakterden az olmalıdır')
        .required('Lütfen geçerli bir başlık giriniz'),
    sentToPhone: yup
        .string('10 rakam olmalıdır')
        .min(10, '10 karakterden fazla olmalıdır')
        .max(10, '10 karakterden az olmalıdır')
        .required('10 rakam olmalıdır'),
    sentBy: yup
        .string('Bağlı olduğu liste IDsi gereklidir.')
        .min(5, '5 karakterden fazla olmalıdır')
        .max(200, '200 karakterden az olmalıdır')
        .required('Bağlı olduğu liste IDsi gereklidir'),
    smsContent: yup
        .string('Bağlı olduğu liste IDsi gereklidir.')
        .min(5, '5 karakterden fazla olmalıdır')
        .max(600, '600 karakterden az olmalıdır')
        .required('Bağlı olduğu liste IDsi gereklidir'),
});

const removeWhitespace = (text) => {
    return text.replace(/\s/g, '');
};
const formatPhoneNumberTurkey = (phone) => {
    const formattedPhone = removeWhitespace(phone);
    if (formattedPhone.length === 10) return `${formattedPhone}`;
    return formattedPhone.replace(/\s/g, '').replace(/^0/g, '');
};

export default function InputArea(props) {
    const { initial, content, handleClose, number } = props;

    const queryClient = useQueryClient();

    const [disableOnSubmit, setDisableOnSubmit] = useState(false);
    const user = JSON.parse(localStorage.getItem('user'));
    const { userID } = user;
    const formik = useFormik({
        initialValues: {
            relatedID: initial?.relatedID || '',
            sentBy: initial?.sentBy || userID,
            sentToPhone: initial?.sentToPhone || '',
            smsHeader: initial?.smsHeader || 'KAPIM',
            smsContent: initial?.smsContent || '',
            sourcePage: initial?.sourcePage || 'customer',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            setDisableOnSubmit(true);

            postSMS(values)
                .then((rp) => {
                    notify(rp.data.success, rp.data.message);
                    handleClose();
                    queryClient.invalidateQueries({ queryKey: ['fetchSms'] });
                })
                .catch((err) => notify(false, JSON.stringify(err)));
        },
    });
    useEffect(() => {
        if (content) formik.setFieldValue('smsContent', content);
    }, [content]);

    useEffect(() => {
        if (number) formik.setFieldValue('sentToPhone', formatPhoneNumberTurkey(number));
    }, [number]);

    return (
        <Card id="basic-info" sx={{ overflow: 'visible' }}>
            <form onSubmit={formik.handleSubmit}>
                <MDBox p={3}>
                    <Grid container spacing={3}>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6,
                            }}
                        >
                            <Autocomplete
                                label="Gönderen"
                                size="small"
                                multiple={false}
                                // defaultValue={['react', 'angular']}
                                options={['KAPIM', 'KAHRAMNLRAS']}
                                value={formik.values.smsHeader}
                                onChange={(e, value) => {
                                    formik.setFieldValue('smsHeader', value !== null ? value : initial.tags);
                                }}
                                renderInput={(params) => (
                                    <FormField
                                        {...params}
                                        label="Gönderen"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6,
                            }}
                        >
                            <FormField
                                label="Alıcı Telefon"
                                placeholder="Alıcının Telefonu"
                                id="sentToPhone"
                                name="sentToPhone"
                                value={formik.values.sentToPhone}
                                onChange={formik.handleChange}
                                error={formik.touched.sentToPhone && Boolean(formik.errors.sentToPhone)}
                                helperText={formik.touched.sentToPhone && formik.errors.sentToPhone}
                            />
                        </Grid>

                        <Grid
                            size={{
                                xs: 12,
                                sm: 12,
                            }}
                        >
                            <FormField
                                label="SMS içeriği"
                                placeholder="SMS içeriği"
                                id="smsContent"
                                name="smsContent"
                                multiline
                                row={5}
                                value={formik.values.smsContent}
                                onChange={formik.handleChange}
                                error={formik.touched.smsContent && Boolean(formik.errors.smsContent)}
                                helperText={formik.touched.smsContent && formik.errors.smsContent}
                            />
                        </Grid>

                        <Grid size={12}>
                            <Grid
                                size={{
                                    xs: 12,
                                    sm: 12,
                                }}
                            >
                                <MDButton
                                    fullWidth
                                    size="small"
                                    variant="gradient"
                                    color="dark"
                                    type="submit"
                                    disabled={disableOnSubmit}
                                >
                                    Ekle
                                </MDButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </MDBox>
            </form>
        </Card>
    );
}
